import { NgModule }                               from '@angular/core';
import { BrowserModule }                          from '@angular/platform-browser';
//**********************************************************************
import { LOCALE_ID }                              from '@angular/core';
import {  registerLocaleData, 
          CommonModule,
          DatePipe  
        }                                         from '@angular/common';
import localeEnAU                                 from '@angular/common/locales/en-AU';
//**********************************************************************
import { AppRoutingModule }                       from './app-routing.module';
import { AppComponent }                           from './app.component';
//**********************************************************************
// Firestore Configurations
import { firestoreEnvironment }       from '../environments/firestore.environment';
//**********************************************************************
// Angular Firestore Modules
import { AngularFireModule }          from '@angular/fire/compat'
import { AngularFirestoreModule }     from '@angular/fire/compat/firestore';
import { AngularFireStorageModule }   from '@angular/fire/compat/storage';
import { AngularFireAuthModule }      from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule }  from '@angular/fire/compat/database';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
//**********************************************************************
// Firestore 
import { firestorecontrol }           from '../app/appfirestore/app.firestore';
//**********************************************************************
// Google Maps
import { AgmCoreModule }                    from '@agm/core';
//import { GoogleMapsModule } from '@angular/google-maps'
//**********************************************************************
import { HttpClientModule }                 from '@angular/common/http';
//**********************************************************************
// Components
import { ComhomeComponent }                 from './components/comhome/comhome.component';
import { ComloginComponent }                from './components/comlogin/comlogin.component';
import { ComeventprofilesComponent }        from './components/comeventprofiles/comeventprofiles.component';
import { CominviteesnapshotComponent }      from './components/cominviteesnapshot/cominviteesnapshot.component';
import { CominviteedetailComponent }        from './components/cominviteedetail/cominviteedetail.component';
import { CominviteeinviteComponent }        from './components/cominviteeinvite/cominviteeinvite.component';
import { CominviteegiftregisterComponent }  from './components/cominviteegiftregister/cominviteegiftregister.component';
import { CominviteersvpComponent }          from './components/cominviteersvp/cominviteersvp.component';
import { CominviteeseatingComponent }       from './components/cominviteeseating/cominviteeseating.component';
import { CominviteegiftthankyouComponent }  from './components/cominviteegiftthankyou/cominviteegiftthankyou.component';
import { ComtodolistsnapshotComponent }     from './components/comtodolistsnapshot/comtodolistsnapshot.component';
import { ComappointmentsnapshotComponent }  from './components/comappointmentsnapshot/comappointmentsnapshot.component';
import { ComtodoComponent }                 from './components/comtodo/comtodo.component';
import { ComappointmentComponent }          from './components/comappointment/comappointment.component'
import { CommfinancesnapshotComponent }     from './components/commfinancesnapshot/commfinancesnapshot.component';
import { ComfinanceComponent }              from './components/comfinance/comfinance.component';

import { ComadminComponent }                from './components/comadmin/comadmin.component';
import { ComfaqComponent }                  from './components/comfaq/comfaq.component';
//**********************************************************************
// Dialog Boxes
import { ComstripepaymentComponent }        from './components/comstripepayment/comstripepayment.component';

// Stripe
import { StripeModule }                    from "stripe-angular"
import { NgxStripeModule }                  from 'ngx-stripe';

//**********************************************************************
// Devextreme 
import { DevExtremeModule }                 from 'devextreme-angular';
//**********************************************************************
// FontAwesome Icons
import { FontAwesomeModule }                from '@fortawesome/angular-fontawesome';
import { FaIconLibrary }                    from '@fortawesome/angular-fontawesome';
import { faStar as farStar }                from '@fortawesome/free-regular-svg-icons';
import { faStar as fasStar }                from '@fortawesome/free-solid-svg-icons'
import { faFilm }                           from '@fortawesome/free-solid-svg-icons';
//**********************************************************************
// Functions
import { appfunctions }                     from  './functions/app.functions';
//**********************************************************************
// Others
import { MatDialogModule }                  from '@angular/material/dialog';
import { MatButtonModule }                  from '@angular/material/button';
import { BrowserAnimationsModule }          from '@angular/platform-browser/animations'; 
import { NoopAnimationsModule }             from '@angular/platform-browser/animations';
//**********************************************************************
// Pipes
import { getformattextpipe }                from "./pipes/formattext"
import { getorganiserinitpipe }             from "./pipes/getorgansierinitial"
import { getextractinviteenamepipe }        from "./pipes/getname";
import { getdatediff }                      from "./pipes/nodaydiff";

//**********************************************************************
// Registering LOCALE ID
registerLocaleData(localeEnAU);  // Australia


@NgModule
(
    {
      declarations: [
                      AppComponent,
                      ComhomeComponent,
                      ComloginComponent,
                      ComeventprofilesComponent,
                      CominviteesnapshotComponent,
                      CominviteedetailComponent,
                      CominviteeinviteComponent,
                      CominviteegiftregisterComponent,
                      CominviteersvpComponent,
                      CominviteeseatingComponent,
                      CominviteegiftthankyouComponent,
                      ComtodolistsnapshotComponent,
                      ComappointmentsnapshotComponent,
                      ComtodoComponent,
                      ComappointmentComponent, 
                      CommfinancesnapshotComponent,
                      ComfinanceComponent,

                      // Stripe Payment Components
                      ComstripepaymentComponent,

                      // FAQ Components
                      ComadminComponent,
                      ComfaqComponent,

                      // Pipes
                      getformattextpipe,
                      getorganiserinitpipe,
                      getextractinviteenamepipe,
                      getdatediff
                      
                    ],
               
  imports:          [
                      BrowserModule,
                      CommonModule,
                      AppRoutingModule,

                      // DevExtreme
                      DevExtremeModule,

                      // Angular Fire
                      AngularFireModule.initializeApp( firestoreEnvironment.firestore_config ),
                      AngularFirestoreModule.enablePersistence(),
                      AngularFireStorageModule, 
                      AngularFireDatabaseModule,
                      AngularFireFunctionsModule,
                      
                      NoopAnimationsModule, // storage

                      // Dialogue 
                      MatDialogModule,
                      MatButtonModule,
                      BrowserAnimationsModule,

                      // FontAwesome Icons
                      FontAwesomeModule,


                      // GoogleMapsModule
                      AgmCoreModule.forRoot
                      (
                        {
                          apiKey: 'AIzaSyDXP7eW--Hq-7TLA_t4evfg2-_PvgxO8fE',
                          libraries: ["places", "geometry"]
                        }
                      ),
                    
                      // Stripe Module
                      NgxStripeModule.forRoot('pk_test_axi5SnPRgai8z56Yc8QM3AKl'),
                
                      //StripeModule.forRoot('pk_test_axi5SnPRgai8z56Yc8QM3AKl'),
                    
                      
                      HttpClientModule
                    ],

  providers:        [
                      firestorecontrol,
                      appfunctions,
                      DatePipe,
                      // setting local ISO Code en-Country Code i.e en-AU means australia code
                      { provide: LOCALE_ID, useValue: 'en-AU' }

                    ],

  bootstrap:        [
                      AppComponent
                    ]
    }
)

export class AppModule 
  { 
    //**********************************************************************
    constructor (
                  library: FaIconLibrary 
                )
                    {
                        library.addIcons(fasStar, farStar, faFilm);
                    }
    //**********************************************************************
  }
